import _ from "lodash";
import { decimalString } from "src/constants/types";
import { roundAmount } from "./helpers";
import { ICurrencyConfig } from "src/constants/interfaces";
import { ISelection } from "src/constants/interfaces/bet";

export interface ISystemVariantMemberSelection {
    index: number;
    price: number;
}

export interface ISystemVariant {
    name: string;
    totalPrice: number;
    isBanker?: boolean;
}

const factorial = _.memoize((x: number): number => (
    x <= 0 ? 1 : (x * factorial(x - 1))
));

export const getSystemOptionVariantsCount = _.memoize((combinationCount: number, betsCount: number) => (
    Math.round(factorial(betsCount) / (factorial(combinationCount) * factorial(betsCount - combinationCount)))
), (...args) => args.join('_'));

export const findSystemOptionVariantMembers = (selections: ISystemVariantMemberSelection[], systemCombinationCount: number): ISystemVariantMemberSelection[][] => {
    if (systemCombinationCount === 0) return [[]];

    if (selections.length === 0 || systemCombinationCount > selections.length) return [];

    const head = selections[0];
    const tail = selections.slice(1);

    const combinationsWithHead = findSystemOptionVariantMembers(tail, systemCombinationCount - 1).map((combo) => [head, ...combo]);

    const combinationsWithoutHead = findSystemOptionVariantMembers(tail, systemCombinationCount);

    return [...combinationsWithHead, ...combinationsWithoutHead];
}

export const getSystemOptionVariants = (selections: ISelection[], systemCombinationCount: number): ISystemVariant[] => {
    const simplifiedSelections = selections
        .map((item, index) => ({ index, price: item.event.price, isBanker: item.isBanker }))
        .filter(item => !item.isBanker);

    const allVariants = findSystemOptionVariantMembers(simplifiedSelections, systemCombinationCount);

    return allVariants.map(variant => ({
        name: variant.map(item => item.index + 1).join('/'),
        totalPrice: variant.reduce((acc, item) => acc * item.price, 1),
    }));
}

export const getSystemUnitFromTotal = (stake: decimalString, optionVariantsCount: number, currencyConfig?: ICurrencyConfig) => (
    `${stake ? roundAmount(+stake / optionVariantsCount, currencyConfig, false) : ''}` as decimalString
);

export const getSystemTotalFromUnit = (stake: decimalString, optionVariantsCount: number, currencyConfig?: ICurrencyConfig) => (
    `${stake ? roundAmount(+stake * optionVariantsCount, currencyConfig, false) : ''}` as decimalString
);